import { AxiosPromise, AxiosResponse } from 'axios';
import { TranslateFunction } from 'react-localize-redux';

import { AxiosError, Result } from '../types/data.types';

export const fdApiUse = <T>(
  request: AxiosPromise,
  isUnstructuredData = false,
): Promise<T> =>
  new Promise((resolve, reject) => {
    request
      .then((result) => {
        const { data }: AxiosResponse = result;

        if (isUnstructuredData) {
          resolve(data);
        } else if (data.Success) {
          resolve(data.Data);
        } else {
          reject(data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });

export const getUserMessage = (
  error: AxiosError | Result<any> | any,
  translate: TranslateFunction,
): string => {
  // Result<any> - comes from rejected promise in apiUtils.use function Result.Success === false
  if (error?.UserMessage) {
    return error?.UserMessage;
  }

  // AxiosError - comes straight from API error
  if (error?.response?.data?.UserMessage) {
    return error.response.data.UserMessage;
  }

  // DefaultError - getting translateId for fallback error message 'Unexpected error occurred'
  const defaultMessage = translate('Unexpected_error_occurred') as string;
  return defaultMessage;
};
